import React from 'react'
import Header from './email-builder/elements/Header'
import { Container } from './email-builder/elements/Container'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'

export interface IEmailTemplateProps {
  backgroundColor?: string
  linkColor?: string
  buttonPrimary?: string
  logoSrc?: string | null
  companyName?: string
}

export const OrgContext = React.createContext<IEmailTemplateProps>(null as any)

export const EmailTemplate: React.FC<IEmailTemplateProps> = (props) => {
  return (
    <I18nProvider i18n={i18n}>
      <Container>
        <OrgContext.Provider
          value={{
            ...props
          }}
        >
          <Header
            data={{
              logoSrc: props.logoSrc,
              backgroundColor: props.backgroundColor || '#ffffff',
              companyName: props.companyName || 'Looop'
            }}
          />

          {props.children}
        </OrgContext.Provider>
      </Container>
    </I18nProvider>
  )
}
